import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function ReportIcon({ width = 24, height = 24, color = 'black' }) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <Path d="M22 21H2V3h2v16h2v-9h4v9h2V6h4v13h2v-5h4v7z" fill={color} />
    </Svg>
  );
}

export default ReportIcon;
